import { render, staticRenderFns } from "./VNavigation.vue?vue&type=template&id=e2d61db2&scoped=true&"
import script from "./VNavigation.vue?vue&type=script&lang=js&"
export * from "./VNavigation.vue?vue&type=script&lang=js&"
import style0 from "./VNavigation.vue?vue&type=style&index=0&id=e2d61db2&lang=scss&scoped=true&"
import style1 from "./VNavigation.vue?vue&type=style&index=1&id=e2d61db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d61db2",
  null
  
)

export default component.exports